import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { Button } from '@library/components/buttons';

export interface UploadCSVButtonProps {
  disabled?: boolean;
  handleOnClick: () => void;
  buttonText?: string;
}

export const UploadCSVButton = ({
  disabled = false,
  handleOnClick,
  buttonText = ''
}: UploadCSVButtonProps) => {
  return (
    <Button
      className="border-soFresh-140 hover:bg-soFresh-120 bg-soFresh-110 disabled:bg-soFresh-130 text-soClean-140 flex items-center gap-2 rounded-md border p-3 text-sm"
      data-testid="upload-csv"
      disabled={disabled}
      title="UploadCSVButton"
      onClick={handleOnClick}
    >
      <ArrowDownTrayIcon className="size-5" />
      {buttonText}
    </Button>
  );
};
